var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsotype(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L5.39052 3.2396V9.68759L0 6.44809V0Z",
    fill: "#4875CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30078 3.18726L10.6912 6.42685V12.8748L5.30078 9.63525V3.18726Z",
    fill: "#5B9FFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6094 6.37451L15.9999 9.61402V16L10.6094 12.8228V6.37451Z",
    fill: "#5FB6FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.68823L5.40601 12.7497L0 15.9986V9.68823Z",
    fill: "#4875CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 0.00341797V6.31375L10.5918 3.25233L15.9978 0.00341797Z",
    fill: "#5FB6FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotype);
export default __webpack_public_path__ + "static/media/Isotype.113a52e60f598dea4955fb52d0a51b34.svg";
export { ForwardRef as ReactComponent };